import React, { Component, Fragment } from "react";
import { withRouter, Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import TaskEditForm from "../../forms/tasks/TaskEditForm";
import Materialicon from "../../helpers/Materialicon";

class TaskEditPage extends Component {  
	render() {
		return (
			<div className="crud-page task-edit-page">
				<div className="container-fluid">
					<section className="actions">
						<Row>
							<Col md={6} sm={6} xs={12}>
								<h2 className="page-title">Edit Task</h2>
							</Col>
							<Col md={6} sm={6} xs={12}>
								<Link to="/tasks/all-tasks" className="pull-right btn-add-big btn btn-default">
									<Materialicon icon="keyboard_arrow_left" /> Back to Tasks
								</Link>
							</Col>
						</Row>   
					</section>
					<div className="card card-top-border connection-card fadeInLoadUp">
						<TaskEditForm {...this.props}/>					
					</div>   
				</div>
			</div>
	  	);
   	}
}
TaskEditPage.propTypes = {};
export default TaskEditPage;




// WEBPACK FOOTER //
// ./src/components/pages/tasks/TaskEditPage.js